module.exports = __webpack_public_path__ + "beschreibung_einzel_karte.png?0f26ab42dd708812b1411e6fe248f686";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/beschreibung_einzel_karte.png
// module id = 11
// module chunks = 0